import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Box,
  InputAdornment,
  Badge,
  Tooltip,
  Fade,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  Avatar,
  ToggleButton,
  ToggleButtonGroup,
  Menu,
  MenuItem,
  Select,
  Divider,
  Collapse,
  DialogContent,
  Zoom,
  Switch,
  FormGroup,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import FilterListIcon from '@mui/icons-material/FilterList';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import axios from '../../axios';
import './animation.css';

// Styled components - matching blog/review/casestudy patterns
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  textAlign: 'left',
  backgroundColor: '#1a3a4a',
  padding: '12px 16px',
  whiteSpace: 'nowrap',
  fontSize: '0.8rem',
  letterSpacing: '0.03em',
  borderBottom: '2px solid rgba(255,255,255,0.1)',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    transition: 'background-color 0.2s ease',
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  transition: 'all 0.3s ease',
  border: '1px solid #e8ecf0',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
  },
}));

const HeaderPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
  borderRadius: '12px',
  padding: '16px 24px',
  marginBottom: '16px',
  boxShadow: '0 4px 20px rgba(19, 78, 94, 0.3)',
}));

const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

const getStatusColor = (status) => {
  return status === 'Y' ? 'success' : 'error';
};

const getStatusLabel = (status) => {
  return status === 'Y' ? 'Active' : 'Inactive';
};

const UsersControl = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [viewMode, setViewMode] = useState('grid');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Filter states
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilter, setActiveFilter] = useState('all');

  // Input fields
  const [UserCode, setUserCode] = useState('');
  const [UserName, setUserName] = useState('');
  const [Email, setEmail] = useState('');
  const [PhoneNumber, setPhoneNumber] = useState('');
  const [UserPassword, setUserPassword] = useState('');
  const [ActiveStatus, setActiveStatus] = useState('Y');

  const [usersData, setusersData] = useState([]);
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();

  const [errors, setErrors] = useState({
    UserCode: false,
    UserName: false,
    Email: false,
    PhoneNumber: false,
    UserPassword: false,
    ActiveStatus: false,
  });

  const [helperTexts, setHelperTexts] = useState({
    UserCode: '',
    UserName: '',
    Email: '',
    PhoneNumber: '',
    UserPassword: '',
    ActiveStatus: '',
  });

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllUsers', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setusersData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      setOpenLoader(false);
    }
  };

  const InsertUser = async (newUser) => {
    try {
      await axios.instance.post('/InsertUsers', newUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      getUsers();
      setAlertType('success');
      setAlertMessage('New User Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding User:', error);
      setAlertType('error');
      setAlertMessage('Failed to add the User.');
      setopenAlert(true);
    }
  };

  const updateUser = async (userId, updatedUser) => {
    try {
      await axios.instance.put(`/UpdateUsers/${userId}`, updatedUser, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setopenAlert(true);
      setEditID();
      getUsers();
      setAlertType('success');
      setAlertMessage('User Updated Successfully!');
    } catch (error) {
      console.error('Error updating User:', error);
      setAlertType('error');
      setAlertMessage('Failed to update the User.');
      setopenAlert(true);
    }
  };

  const deleteUser = async (userId) => {
    try {
      await axios.instance
        .delete(`/DeleteUsers/${userId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            getUsers();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('User Deleted Successfully!');
            setopenAlert(true);
          } else {
            getUsers();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
        });
    } catch (error) {
      console.error('Error deleting User:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the User.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setUserCode('');
    setUserName('');
    setEmail('');
    setPhoneNumber('');
    setUserPassword('');
    setActiveStatus('Y');
    Object.keys(errors).forEach((key) => {
      errors[key] = false;
      helperTexts[key] = '';
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const inputValidation = !UserCode || !UserName || !Email || !PhoneNumber || !UserPassword || !ActiveStatus;

    if (inputValidation) {
      if (!UserCode) {
        setErrors((prev) => ({ ...prev, UserCode: true }));
        setHelperTexts((prev) => ({ ...prev, UserCode: 'Please enter user code' }));
      }
      if (!UserName) {
        setErrors((prev) => ({ ...prev, UserName: true }));
        setHelperTexts((prev) => ({ ...prev, UserName: 'Please enter user name' }));
      }
      if (!Email) {
        setErrors((prev) => ({ ...prev, Email: true }));
        setHelperTexts((prev) => ({ ...prev, Email: 'Please enter email' }));
      }
      if (!PhoneNumber) {
        setErrors((prev) => ({ ...prev, PhoneNumber: true }));
        setHelperTexts((prev) => ({ ...prev, PhoneNumber: 'Please enter phone number' }));
      }
      if (!UserPassword) {
        setErrors((prev) => ({ ...prev, UserPassword: true }));
        setHelperTexts((prev) => ({ ...prev, UserPassword: 'Please enter password' }));
      }
      if (!ActiveStatus) {
        setErrors((prev) => ({ ...prev, ActiveStatus: true }));
        setHelperTexts((prev) => ({ ...prev, ActiveStatus: 'Please select status' }));
      }
      setIsSubmitting(false);
      return;
    }

    const newData = {
      UserCode,
      UserName,
      Email,
      PhoneNumber,
      UserPassword,
      ActiveStatus,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: 86,
    };

    try {
      if (operation === 'Add') {
        await InsertUser(newData);
      } else {
        await updateUser(editID, newData);
      }
      resetFields();
      handleClose();
    } catch (error) {
      console.error('Error saving user:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'UserCode') setUserCode(value);
    if (name === 'UserName') setUserName(value);
    if (name === 'Email') setEmail(value);
    if (name === 'PhoneNumber') setPhoneNumber(value);
    if (name === 'UserPassword') setUserPassword(value);
    if (name === 'ActiveStatus') setActiveStatus(value);
    validateInput(name, value);
  };

  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const contactRegex = /^\d{10}$/;

    if (name === 'UserName') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      } else if (!nameRegex.test(value)) {
        error = true;
        helperText = 'Please enter a valid name';
      }
    } else if (name === 'UserCode') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      }
    } else if (name === 'Email') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      } else if (!emailRegex.test(value)) {
        error = true;
        helperText = 'Please enter a valid email';
      }
    } else if (name === 'PhoneNumber') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      } else if (!contactRegex.test(value)) {
        error = true;
        helperText = 'Please enter a 10-digit phone number';
      }
    } else if (name === 'UserPassword') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    setHelperTexts((prev) => ({ ...prev, [name]: helperText }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      validateInput(name, value);
    }
  };

  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
    resetFields();
  };

  const handleEdit = (user) => {
    setEditID(user.UserAccessID);
    setUserCode(user.UserCode);
    setUserName(user.UserName);
    setEmail(user.Email);
    setPhoneNumber(user.PhoneNumber);
    setUserPassword(user.UserPassword);
    setActiveStatus(user.ActiveStatus);
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (courseId) => {
    setOpenDelete(true);
    setIdToDelete(courseId);
  };

  const handleDeleteConfirmed = () => {
    deleteUser(IdToDelete);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  const handleFilterOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const clearAllFilters = () => {
    setActiveFilter('all');
    setSearchTerm('');
    handleFilterClose();
  };

  // Filter functions
  const getFilteredData = () => {
    let filtered = usersData;

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter((user) =>
        Object.values(user).some((value) => typeof value === 'string' && value.toLowerCase().includes(searchLower))
      );
    }

    if (activeFilter === 'active') {
      filtered = filtered.filter((user) => user.ActiveStatus === 'Y');
    } else if (activeFilter === 'inactive') {
      filtered = filtered.filter((user) => user.ActiveStatus === 'N');
    }

    return filtered;
  };

  const filteredData = getFilteredData();
  const totalRows = filteredData.length;

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilter !== 'all') count += 1;
    if (searchTerm) count += 1;
    return count;
  };

  // Render card view - matching blog/casestudy style
  const renderCardView = () => {
    const displayData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <Grid container spacing={3}>
        {displayData.map((user) => (
          <Grid item xs={12} sm={6} md={4} key={user.UserAccessID}>
            <Fade in timeout={400}>
              <StyledCard>
                <Box sx={{ position: 'relative' }}>
                  <Box
                    sx={{
                      height: 120,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'primary.light',
                      position: 'relative',
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 72,
                        height: 72,
                        bgcolor: 'primary.main',
                        fontSize: '2rem',
                        fontWeight: 600,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                      }}
                    >
                      {getInitials(user.UserName)}
                    </Avatar>
                    <Chip
                      label={getStatusLabel(user.ActiveStatus)}
                      color={getStatusColor(user.ActiveStatus)}
                      size="small"
                      sx={{
                        position: 'absolute',
                        top: 12,
                        right: 12,
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Box>

                <CardHeader
                  title={
                    <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
                      {user.UserName}
                    </Typography>
                  }
                  subheader={
                    <Chip
                      label={user.UserCode}
                      size="small"
                      sx={{ bgcolor: 'primary.light', color: 'primary.main', fontWeight: 600, fontSize: '0.7rem' }}
                    />
                  }
                  sx={{ pb: 0 }}
                />

                <CardContent sx={{ flexGrow: 1, pt: 1 }}>
                  <Stack spacing={1}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <EmailIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary">
                        {user.Email}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <PhoneIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary">
                        {user.PhoneNumber}
                      </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <VpnKeyIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                      <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                        ••••••••
                      </Typography>
                    </Stack>
                  </Stack>
                </CardContent>

                <CardActions sx={{ justifyContent: 'flex-end', pt: 1, pb: 2, px: 2 }}>
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEdit(user)} sx={{ color: 'primary.main' }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(user.UserAccessID)}
                      sx={{ color: 'error.main' }}
                    >
                      <DeleteForeverIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </CardActions>
              </StyledCard>
            </Fade>
          </Grid>
        ))}
      </Grid>
    );
  };

  // Render table view
  const renderTableView = () => {
    const displayData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" sx={{ width: 60 }}>
                #
              </StyledTableCell>
              <StyledTableCell>User Code</StyledTableCell>
              <StyledTableCell>User Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Phone</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell align="center" sx={{ width: 120 }}>
                Actions
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayData.map((user, index) => (
              <StyledTableRow key={user.UserAccessID}>
                <TableCell align="center" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                  {page * rowsPerPage + index + 1}
                </TableCell>
                <TableCell>
                  <Chip
                    label={user.UserCode}
                    size="small"
                    sx={{ bgcolor: 'primary.light', color: 'primary.main', fontWeight: 600, fontSize: '0.75rem' }}
                  />
                </TableCell>
                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.75rem' }}>
                      {getInitials(user.UserName)}
                    </Avatar>
                    <Typography variant="body2" fontWeight={500}>
                      {user.UserName}
                    </Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <EmailIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                    <Typography variant="body2">{user.Email}</Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <PhoneIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                    <Typography variant="body2">{user.PhoneNumber}</Typography>
                  </Stack>
                </TableCell>
                <TableCell>
                  <Chip
                    icon={user.ActiveStatus === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    label={getStatusLabel(user.ActiveStatus)}
                    color={getStatusColor(user.ActiveStatus)}
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => handleEdit(user)} sx={{ color: 'primary.main' }}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(user.UserAccessID)}
                      sx={{ color: 'error.main' }}
                    >
                      <DeleteForeverIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <>
      <style>{`
        /* Sticky Dialog Styles */
        .sticky-dialog .MuiDialog-paper {
          display: flex;
          flex-direction: column;
          max-height: 95vh;
        }
        .sticky-dialog .MuiDialogContent-root {
          flex: 1 1 auto;
          overflow-y: auto;
          padding: 24px;
        }
        .sticky-dialog .MuiDialogActions-root {
          flex-shrink: 0;
        }
        .sticky-dialog .MuiDialogTitle-root {
          flex-shrink: 0;
        }
      `}</style>

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Slide}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%', borderRadius: 2 }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
        {/* Header - Consistent with Case Study Master */}
        <HeaderPaper elevation={0}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <AdminPanelSettingsIcon sx={{ color: 'white' }} />
              <Typography variant="h6" fontWeight={700} color="white" sx={{ letterSpacing: '0.02em' }}>
                Users Management
              </Typography>
            </Stack>
            <Typography variant="caption" color="rgba(255,255,255,0.7)">
              Total: {usersData.length} users
            </Typography>
          </Stack>
        </HeaderPaper>

        {/* Search & Actions Bar */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          sx={{ mb: 3 }}
        >
          <TextField
            placeholder="Search users..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ maxWidth: { sm: 300 }, width: '100%' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="row" spacing={1} alignItems="center">
            <Badge badgeContent={getActiveFilterCount()} color="primary" invisible={getActiveFilterCount() === 0}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={handleFilterOpen}
                size="small"
                sx={{ borderRadius: 2 }}
              >
                Filters
              </Button>
            </Badge>

            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, val) => val && setViewMode(val)}
              size="small"
              sx={{ '& .MuiToggleButton-root': { px: 1.5 } }}
            >
              <ToggleButton value="grid">
                <ViewModuleIcon fontSize="small" />
              </ToggleButton>
              <ToggleButton value="table">
                <ViewListIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>

            <Button
              variant="contained"
              startIcon={<PlaylistAddIcon />}
              onClick={handleAddOpen}
              sx={{ borderRadius: 2, boxShadow: 2 }}
            >
              Add User
            </Button>
          </Stack>
        </Stack>

        {/* Filter Menu */}
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          PaperProps={{
            sx: {
              maxWidth: 280,
              width: '100%',
            },
          }}
        >
          <Box sx={{ p: 2 }}>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              Filter Users
            </Typography>

            <FormControl fullWidth size="small" sx={{ mt: 1 }}>
              <FormLabel sx={{ fontSize: '0.75rem', fontWeight: 500 }}>Status</FormLabel>
              <Select
                value={activeFilter}
                onChange={(e) => setActiveFilter(e.target.value)}
                variant="outlined"
                size="small"
              >
                <MenuItem value="all">All Users</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>

            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Button variant="contained" size="small" fullWidth onClick={clearAllFilters} startIcon={<ClearIcon />}>
                Clear All
              </Button>
              <Button variant="outlined" size="small" fullWidth onClick={handleFilterClose}>
                Apply
              </Button>
            </Stack>
          </Box>
        </Menu>

        {/* Results count */}
        {filteredData.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Showing {filteredData.length} user{filteredData.length !== 1 ? 's' : ''}
          </Typography>
        )}

        {/* Content */}
        {filteredData.length === 0 ? (
          <Paper sx={{ textAlign: 'center', py: 6, borderRadius: 3 }}>
            <Typography variant="h6" color="text.secondary">
              No users found
            </Typography>
            <Typography variant="body2" color="text.disabled">
              Try adjusting your filters or add a new user
            </Typography>
          </Paper>
        ) : viewMode === 'grid' ? (
          <>
            {renderCardView()}
            <TablePagination
              rowsPerPageOptions={[6, 12, 24]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={Math.min(page, Math.ceil(totalRows / rowsPerPage) - 1)}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{ mt: 2 }}
            />
          </>
        ) : (
          <Paper sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid #e8ecf0' }}>
            {renderTableView()}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={Math.min(page, Math.ceil(totalRows / rowsPerPage) - 1)}
              onPageChange={(e, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{ borderTop: '1px solid #e8ecf0' }}
            />
          </Paper>
        )}
      </Container>

      {/* Add/Edit Dialog - Redesigned with Sticky Header & Footer */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullScreen={isMobile}
        fullWidth
        className="sticky-dialog"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Sticky Header */}
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              py: 2,
              pr: 2,
              flexWrap: 'wrap',
              gap: 1,
              flexShrink: 0,
              position: 'sticky',
              top: 0,
              zIndex: 10,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              {`${operation} User`}
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          {/* Scrollable Content */}
          <DialogContent
            sx={{
              p: 3,
              overflow: 'auto',
              flex: '1 1 auto',
              '&:first-of-type': { pt: 3 },
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="User Code"
                  name="UserCode"
                  value={UserCode}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.UserCode}
                  helperText={helperTexts.UserCode}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="User Name"
                  name="UserName"
                  value={UserName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.UserName}
                  helperText={helperTexts.UserName}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Email"
                  name="Email"
                  type="email"
                  value={Email}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.Email}
                  helperText={helperTexts.Email}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Phone Number"
                  name="PhoneNumber"
                  value={PhoneNumber}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.PhoneNumber}
                  helperText={helperTexts.PhoneNumber}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Password"
                  name="UserPassword"
                  type="password"
                  value={UserPassword}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.UserPassword}
                  helperText={helperTexts.UserPassword}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VpnKeyIcon fontSize="small" color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>

          {/* Sticky Footer with Switch and Buttons */}
          <DialogActions
            sx={{
              p: 2,
              borderTop: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              gap: 2,
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {/* Left side - Status Switch */}
            <Stack direction="row" spacing={2} alignItems="center">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      checked={ActiveStatus === 'Y'}
                      onChange={(e) =>
                        handleInputChange({ target: { name: 'ActiveStatus', value: e.target.checked ? 'Y' : 'N' } })
                      }
                      color="success"
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      {ActiveStatus === 'Y' ? 'Active' : 'Inactive'}
                    </Typography>
                  }
                />
              </FormGroup>
            </Stack>

            {/* Right side - Action Buttons */}
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={handleClose} size="medium">
                Cancel
              </Button>
              <Button type="submit" variant="contained" disabled={isSubmitting} size="medium">
                {isSubmitting ? 'Saving...' : operation === 'Add' ? 'Create User' : 'Update User'}
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 600 }}>Delete User?</DialogTitle>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button variant="outlined" onClick={handleCloseDelete}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDeleteConfirmed}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loader */}
      <Dialog open={openLoader} fullWidth>
        <LinearProgress sx={{ height: 4 }} />
      </Dialog>
    </>
  );
};

export default UsersControl;
